import React from 'react';
import HomePage from './components/pages/HomePage';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-N4TF1JBK2S');
ReactGA.send('pageview');
function App() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default App;
